import styled from "styled-components";
import { BaseModalDialogPaper } from "Components/Modal/BaseModal.styles";

export const EditContactModalDialogPaper = styled(BaseModalDialogPaper)`
    min-width: 420px;

    .MuiDialogContent-root {
        p {
            padding-bottom: 40px;
            font-size: 14px;
        }
    }
`;
